function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.064 14.081H7.249a.334.334 0 01-.22-.584L18.545 3.364A1.92 1.92 0 0016.012.481L1.104 13.6a3.2 3.2 0 000 4.8l14.905 13.116a1.92 1.92 0 002.533-2.881L7.026 18.502a.335.335 0 01.22-.584h22.817a1.92 1.92 0 000-3.839z"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgArrowLeft;